/**
 * Sidebar Constants
 * Centralized constants for the Sidebar component
 */
import { WebConfig } from '../web-config';

export const DRAWER_WIDTH = 240;
export const COLLAPSED_WIDTH = 64;

export const SIDEBAR_MENU_ID = 'sidebar-user-menu';
export const SIDEBAR_MENU_BUTTON_ID = 'sidebar-user-menu-button';

export const AAI_PLATFORM_URL = `${WebConfig.REACT_APP_AAI_SSO_BASE_URL}`;
